












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'admiral-checkbox',
  components: {},
})
export default class AdmiralCheckbox extends Vue {
  @Prop({ required: false, type: Boolean, default: false })
  checked!: boolean;

  change() {
    this.$emit('update', !this.checked);
  }
}
